import c from "classnames";
import { ComponentProps, ReactNode } from "react";

import { Text } from "@design-system/Text/Text";

import classes from "./Tag.module.css";

type Props = {
  text?: string;
  title?: string;
  variant?: "solid" | "light";
  color?:
    | "primary"
    | "secondary"
    | "tertiary"
    | "success"
    | "warning"
    | "danger";
  left?: ReactNode;
  right?: ReactNode;
  maxWidth?: ComponentProps<typeof Text>["maxWidth"];
  noWrap?: boolean;
};

export const Tag = ({
  text,
  title,
  variant = "light",
  color = "primary",
  left,
  right,
  maxWidth,
  noWrap,
}: Props) => {
  return (
    <div
      className={c(classes.tag, classes[variant], classes[color], {
        [classes.noWrap]: noWrap,
      })}
      title={title || text}
    >
      {left}
      <Text
        size={11}
        maxWidth={maxWidth}
        color="inherit"
        truncate
        title={title || text}
      >
        {text}
      </Text>
      {right}
    </div>
  );
};
